import { c as _c } from "react/compiler-runtime";
import type { SerializedEditorState } from '@payloadcms/richtext-lexical/lexical';
import { useTranslations } from 'next-intl';
import type { Media } from '~/payload-types';
import EmbedBlock, { AspectRatio } from './EmbedBlock';
import { getAttachmentSecondaryText, getFileIcon, getVersionedAttachmentUrl } from './attachmentUtils';
export default function KalturaBlock(t0) {
  const $ = _c(12);
  const {
    title,
    description,
    videoId,
    aspectRatio,
    attachments
  } = t0;
  const t = useTranslations();
  const kalturaUrl = `https://api.cast.switch.ch/p/106/embedPlaykitJs/uiconf_id/23449004/partner_id/106?iframeembed=true&playerId=kaltura_player&entry_id=${videoId}`;
  let t1;
  if ($[0] !== aspectRatio || $[1] !== attachments || $[2] !== description || $[3] !== kalturaUrl || $[4] !== t || $[5] !== title) {
    const preparedAttachments = attachments?.flatMap(_temp) ?? [];
    let t2;
    if ($[7] !== aspectRatio || $[8] !== description || $[9] !== kalturaUrl || $[10] !== title) {
      t2 = <EmbedBlock embedUrl={kalturaUrl} title={title} description={description} aspectRatio={aspectRatio} />;
      $[7] = aspectRatio;
      $[8] = description;
      $[9] = kalturaUrl;
      $[10] = title;
      $[11] = t2;
    } else {
      t2 = $[11];
    }
    t1 = <div className="h-full w-full">{t2}{preparedAttachments.length > 0 && <section className="mt-4"><div className="mb-2 flex items-center gap-3"><h3 className="text-xs font-semibold tracking-wide text-gray-600 uppercase">{t("unit.attachmentsHeading")}</h3><div className="h-px flex-1 bg-gray-200" /></div><div className="space-y-2">{preparedAttachments.map(_temp2)}</div></section>}</div>;
    $[0] = aspectRatio;
    $[1] = attachments;
    $[2] = description;
    $[3] = kalturaUrl;
    $[4] = t;
    $[5] = title;
    $[6] = t1;
  } else {
    t1 = $[6];
  }
  return t1;
}
function _temp2(attachment_0) {
  return <a key={attachment_0.id} href={attachment_0.url} target="_blank" rel="noreferrer" download={attachment_0.downloadFilename} className="flex items-start gap-2 rounded-md border border-gray-200 bg-white px-3 py-2 transition-colors hover:bg-gray-50"><span className="mt-0.5 shrink-0">{attachment_0.fileIcon}</span><span className="min-w-0 flex-1"><span className="block truncate text-sm font-medium text-gray-900" title={attachment_0.displayName}>{attachment_0.displayName}</span>{attachment_0.secondaryText && <span className="block text-xs text-gray-600">{attachment_0.secondaryText}</span>}</span></a>;
}
function _temp(attachment) {
  const url = getVersionedAttachmentUrl(attachment);
  if (!url) {
    return [];
  }
  return [{
    id: attachment.id,
    url,
    displayName: attachment.filename ?? "Download",
    secondaryText: getAttachmentSecondaryText(attachment),
    fileIcon: getFileIcon(attachment.filename ?? undefined),
    downloadFilename: attachment.filename ?? undefined
  }];
}